//Api for admin login
import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * Logs in a user with provided credentials and returns the response data.
 *
 * Sends a POST request to the backend API to authenticate the user.
 *
 * @param {Object} credentials - The login credentials.
 * @param {string} credentials.email - The username or email of the user.
 * @param {string} credentials.password - The password of the user.
 * 
 * @returns {Promise<Object>} - The response data containing user info and token.
 * 
 * @throws {Error} - Throws an error if login fails or the server returns an error.
 * 
 * @author Susovan
 */
const loginWithEmail = async (credentials) => {
    return await apiCall(AUTH_ROUTES.LOGIN_API_ENDPOINT, {
    method: "POST",
    body: {
      email: credentials.email,
      password: credentials.password,
    },
    requiresAuth: false,
  });
};

export default loginWithEmail
